import { useDebouncedQueryParam } from 'hooks';
import { useQueryParam } from 'use-query-params';
import {
  KEYWORDS_PARAM,
  POST_TYPE_PARAM,
  REDDIT_ID_PARAM,
  SORT_BY_PARAM,
  TIME_RANGE_PARAM,
} from '../constants';

const useTrendsQueryParams = () => {
  const [timeRange, setTimeRange] = useQueryParam('time_range', TIME_RANGE_PARAM);
  const [sortBy, setSortBy] = useQueryParam('order_by', SORT_BY_PARAM);
  const [postType, setPostType] = useQueryParam('post_type', POST_TYPE_PARAM);
  const [redditId, setRedditId] = useQueryParam('reddit_id', REDDIT_ID_PARAM);
  const {
    param: keywordIds,
    actualValue: actualKeywordIds,
    handleChange: setKeywordIds,
  } = useDebouncedQueryParam<typeof KEYWORDS_PARAM, number[]>({
    name: 'keywords',
    defaultValue: KEYWORDS_PARAM,
  });

  return {
    timeRange,
    setTimeRange,
    sortBy,
    setSortBy,
    postType,
    setPostType,
    keywordIds,
    actualKeywordIds,
    setKeywordIds,
    redditId,
    setRedditId,
  };
};

export default useTrendsQueryParams;
